import { render } from "./logo-auth.vue?vue&type=template&id=4b3c1c25"
import script from "./logo-auth.vue?vue&type=script&lang=js"
export * from "./logo-auth.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__